import { IDocumentCreateForm } from "~/components/Forms/CreateDocument";
import { TSelectItem } from "~/model/common";
import { Document } from "~/schemas/generated/graphql";

export enum DocumentStatus {
  Draft = "draft",
  Active = "active",
  Revoked = "revoked",
  Renewed = "renewed",
  Canceled = "canceled",
}

export const documentStatusSelectItems = [
  { value: DocumentStatus.Draft, label: "Черновик" },
  { value: DocumentStatus.Active, label: "Действующее" },
  { value: DocumentStatus.Revoked, label: "Отозвано" },
  { value: DocumentStatus.Renewed, label: "Действующее (актуализировано)" },
  { value: DocumentStatus.Canceled, label: "Аннулировано" },
];

export const filteredDocumentStatusListByCurrentStatus = (
  statusList: TSelectItem<DocumentStatus>[],
  currentStatus: DocumentStatus
) => {
  switch (currentStatus) {
    case DocumentStatus.Draft:
      return statusList.filter((el) => el.value === DocumentStatus.Active);
    case DocumentStatus.Active:
    case DocumentStatus.Renewed:
      return statusList.filter(
        (el) =>
          el.value === DocumentStatus.Canceled ||
          el.value === DocumentStatus.Revoked
      );
    case DocumentStatus.Revoked:
      return statusList.filter((el) => el.value === DocumentStatus.Renewed);
  }
};

export enum DocumentImportance {
  Important = "important",
  Urgent = "urgent",
}

export const importanceStatus_CreteDocument = [
  { value: DocumentImportance.Important, label: "Важное" },
  { value: DocumentImportance.Urgent, label: "Срочное" },
];

export const defaultDocumentValue_CreteDocument: IDocumentCreateForm = {
  name: "",
  description: "",
  importance: DocumentImportance.Important,
  signedBy: "",
  SubdivisionId: undefined,
  status: DocumentStatus.Draft,
  filesIds: [],
};

export const defaultDocumentValueFromTDocument_CreteDocument = (
  documentInstance: Document
): IDocumentCreateForm => {
  if (!documentInstance) return null;

  return {
    name: documentInstance.name,
    description: documentInstance.description,
    importance: documentInstance.importance as DocumentImportance,
    signedBy: documentInstance.signedBy,
    SubdivisionId: documentInstance.Subdivision?.id,
    status: documentInstance.status as DocumentStatus,
    filesIds: documentInstance.Files.map((el) => ({
      id: el.id,
      fileName: el.name,
    })),
  };
};

interface IRequestCreateDocument {
  name: string;
  description: string;
  importance: DocumentImportance;
  signedBy: string;
  SubdivisionId?: string;
  status?: DocumentStatus;
  filesIds: string[];
}
export const dataToRequest_CreateDocument = (
  data: IDocumentCreateForm,
  externalStatus?: DocumentStatus
): IRequestCreateDocument => ({
  name: data.name,
  description: data.description,
  importance: data.importance,
  signedBy: data.signedBy,
  SubdivisionId: data.SubdivisionId,
  status: data.status || externalStatus,
  filesIds: data.filesIds.map((el) => el.id),
});

const tableFields = [
  "name",
  "description",
  "importance",
  "signedBy",
  "SubdivisionId",
  "status",
  "filesIds",
];
export const resolveFieldsEditDisableByStatus_CreateDocument = (
  status: DocumentStatus
) => {
  switch (status) {
    case DocumentStatus.Active:
    case DocumentStatus.Canceled:
    case DocumentStatus.Renewed:
      return tableFields;
    default:
      return [];
  }
};
